/*
    © 2021 EcomGraduates.com
    https://www.ecomgraduates.com
*/

// Navbar - toggle backdrop on dropdown open
document.querySelectorAll('#navbar .dropdown-toggle').forEach(($dropdown) => {
    $dropdown.addEventListener('show.bs.dropdown', (e) => {
        if (!document.querySelector('.modal-backdrop')) {
            document.body.insertAdjacentHTML(
                'beforeend', '<div id="navbar-modal-backdrop" class="modal-backdrop fade"></div>'
            )
            setTimeout(() => {
                document.querySelector('#navbar-modal-backdrop').classList.add('show')
            }, 200)
            document.documentElement.classList.add('navbar-dropdown-is-open')
        }
    })
    $dropdown.addEventListener('hidden.bs.dropdown', (e) => {
        if (!document.querySelector('#navbar .dropdown-menu.show')) {
            document.querySelector('#navbar-modal-backdrop')?.remove()
            document.documentElement.classList.remove('navbar-dropdown-is-open')
        }
    })
})

// Carousel - Go to corresponding slide on editor
document.addEventListener('shopify:block:select', (e) => {
    const carouselEl = e.target.closest('.carousel')

    if (carouselEl) {
        const selectedSlide = e.target.dataset.index
        bootstrap.Carousel.getOrCreateInstance(carouselEl, { interval: false }).to(selectedSlide)
    }
})

// Newsletter - Scroll to it after submit
if (window.location.href.indexOf('?customer_posted=true') > -1) {
    setTimeout(() => {
        document.querySelector('.newsletter-form').scrollIntoView()
    }, 750)
}

// Featured Products - Init Splide Slider
const initFeaturedProductsSliders = () => {
    document.querySelectorAll('.splide-products:not(.init)')
        .forEach((el) => {
            const splide = new Splide(el, {
                arrows: el.dataset.arrows === 'true',
                pagination: el.dataset.pagination === 'true',
                easing: el.dataset.easing,
                speed: Number(el.dataset.speed),
                autoplay: el.dataset.autoplay === 'true',
                interval: Number(el.dataset.interval),
                perMove: Number(el.dataset.perMove),
                rewind: true,
                mediaQuery: 'min',
                perPage: Number(el.dataset.breakpointXs),
                drag: el.dataset.freeScroll === 'true' ? 'free' : true,
                padding: 0,
                breakpoints: {
                    576: { perPage: Number(el.dataset.breakpointSm), padding: 0 },
                    768: { perPage: Number(el.dataset.breakpointMd), padding: 0 },
                    992: { perPage: Number(el.dataset.breakpointLg), padding: 0 },
                    1200: { perPage: Number(el.dataset.breakpointXl), padding: 0 },
                    1400: { perPage: Number(el.dataset.breakpointXxl), padding: 0 }
                }
            })

            splide.mount()
            el.classList.add('init')
        })
}
initFeaturedProductsSliders()

document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.featured-products')) {
        initFeaturedProductsSliders()
    }
})

document.addEventListener('initFeaturedProductsSliders', () => {
    console.log('test')
    initFeaturedProductsSliders()
}, false)

// Featured Collections - Init Splide Slider
const initFeaturedCollectionsSliders = () => {
    document.querySelectorAll('.splide-collections:not(.init)')
        .forEach((el) => {
            const splide = new Splide(el, {
                type: 'loop',
                arrows: el.dataset.arrows === 'true',
                pagination: el.dataset.pagination === 'true',
                easing: el.dataset.easing,
                speed: Number(el.dataset.speed),
                autoplay: el.dataset.autoplay === 'true',
                interval: Number(el.dataset.interval),
                perMove: Number(el.dataset.perMove),
                rewind: true,
                mediaQuery: 'min',
                perPage: Number(el.dataset.breakpointXs),
                drag: el.dataset.freeScroll === 'true' ? 'free' : true,
                padding: '20%',
                breakpoints: {
                    576: { perPage: Number(el.dataset.breakpointSm), padding: 0 },
                    768: { perPage: Number(el.dataset.breakpointMd), padding: 0 },
                    992: { perPage: Number(el.dataset.breakpointLg), padding: 0 },
                    1200: { perPage: Number(el.dataset.breakpointXl), padding: 0 },
                    1400: { perPage: Number(el.dataset.breakpointXxl), padding: 0 }
                }
            })

            splide.mount()
            el.classList.add('init')
        })
}
initFeaturedCollectionsSliders()

document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.featured-collections')) {
        initFeaturedCollectionsSliders()
    }
})

/*
    Product Sticky ATC  - Handle Visibility
*/
const productStickyATCVisibility = () => {
    const $stickyATC = document.querySelector('.product-sticky-atc')

    if ($stickyATC) {
        const $header = document.querySelector('#shopify-section-header.sticky-top')
        const $stickyATC = document.querySelector('.product-sticky-atc')
        const $atcForm = document.querySelector('.product form[action="/cart/add"]')
        const threshold = $atcForm.getBoundingClientRect().bottom

        window.addEventListener('scroll', () => {
            if (window.scrollY > threshold) {
                $stickyATC.classList.add('show')
                $header.classList.add('hide')
            } else {
                $stickyATC.classList.remove('show')
                $header.classList.remove('hide')
            }
        })
    }
}
productStickyATCVisibility()

/*
    Product Sticky ATC  - Handle variant change
*/
const productStickyATCVariantChange = () => {
    const $variantSelecetor = document.querySelector('.product-sticky-atc select[name="id"]')

    $variantSelecetor?.addEventListener('change', (e) => {
        const variantImage = $variantSelecetor.options[$variantSelecetor.selectedIndex].dataset.variantImg

        if (variantImage) {
            const $img = $variantSelecetor.closest('.product-sticky-atc').querySelector('.product-img')
            $img.setAttribute('src', variantImage)
        }
    })
}
productStickyATCVariantChange()

/*
    Recommended Products
*/
const initRecommendedProducts = () => {
    const recommendedProducts = document.querySelector('.recommended-products')
    if (recommendedProducts) {
        const {
            sectionId, baseUrl, productId, limit
        } = recommendedProducts.dataset
        const url = `${baseUrl}?section_id=${sectionId}&product_id=${productId}&limit=${limit}`
        fetch(url)
            .then((response) => response.text())
            .then((data) => {
                recommendedProducts.closest('.shopify-section').outerHTML = data
                initFeaturedProductsSliders()
                window.initWishlist()
            })
    }
}
initRecommendedProducts()

document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.recommended-products')) {
        initRecommendedProducts()
    }
})
